import React from "react";
import stylesModal from "../../styles/Atoms/ModalComponent/modal";

const Modal = ({ title, subtitle, children, onClose, buttons, visible, width, height, overlayStyle }) => {
  const modalStyle = {
    ...stylesModal.modal,
    width: width,
    height: height,
    display: visible ? "flex" : "none",
    flexDirection: "column"
  };

  return (
    <div style={{ ...stylesModal.modalOverlay, ...overlayStyle }}>
      <div style={modalStyle}>
        <div style={stylesModal.modalHeader}>
          <div>
            <h2 style={stylesModal.modalHeaderH2}>{title}</h2>
            <h4 style={stylesModal.modalHeaderH4}>{subtitle}</h4>
          </div>
          <button style={stylesModal.closeButton} onClick={onClose}>
            &times;
          </button>
        </div>
        <hr style={stylesModal.modalDivider} />
        <div style={{ ...stylesModal.modalContent, flex: "1 1 auto", overflowY: "auto" }}>{children}</div>
        {buttons && (
          <>
            <hr style={stylesModal.modalDivider} />
            <div style={{ ...stylesModal.modalButtons, fontFamily: "Raleway, sans-serif" }}>
              {buttons}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Modal;